import { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { WorkspaceProvider } from './WorkspaceContext'

export function ProtectedWorkspaceRoute() {
  const { workspace_slug } = useParams()

  useEffect(() => {
    if (workspace_slug) {
      window.localStorage.setItem('chrona:last-workspace-slug', workspace_slug)
    }
  }, [workspace_slug])

  return (
    <WorkspaceProvider>
      <Outlet />
    </WorkspaceProvider>
  )
}
